module.exports = __webpack_public_path__ + "img/scene2-1.1446c1f8.jpg";